import { useOperationsStore } from '@operations/AppProvider'
import { useVesselVisitBreadcrumbs } from '@operations/hooks/useVesselVisitBreadcrumbs'
import { useAsyncFetch } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { Breadcrumbs } from 'modules/ui/src/theme/components/breadcrumbs/Breadcrumb'

interface Props {
  visitId?: number
}
export const EquipmentPlanningBreadcrump = observer(({ visitId }: Props) => {
  const { carrierVisitStore } = useOperationsStore()
  useAsyncFetch(() => carrierVisitStore.loadOne(visitId!), [visitId])

  const vesselVisit = carrierVisitStore.items.find(vesselVisit => vesselVisit.id === visitId)
  const { breadcrumbs } = useVesselVisitBreadcrumbs(vesselVisit)

  return <Breadcrumbs items={breadcrumbs} />
})
